/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SetBrandTrackingSettingsRequest} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'
import {SetBrandTrackingSettingsResponse} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'


export const setBrandTrackingSettings = (request: SetBrandTrackingSettingsRequest, options?: CashRequestOptions) => post<SetBrandTrackingSettingsRequest, SetBrandTrackingSettingsResponse>("/2.0/cash/set-brand-tracking-settings", request, {...options, rejectOnError: true })